import { TextField } from '@material-ui/core/';

interface ModalInputProps {
    value: string;
    onChange: (e: string) => void;
    multiline?: boolean;
}

export function ModalInput({ value, onChange, multiline }: ModalInputProps) {
    return (
        <TextField 
            type='text'
            value={value}
            onChange={(e) => onChange(e.target.value)}
            color='primary'
            variant='outlined'
            style={{ margin: '6px 0px'}}
            multiline={multiline}
        />
    )
}